import { Component, OnInit, NgZone  } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Activity, ActivityCategory, ActivityStatus } from '../../model/activity';
import { Bidding, BiddingStatus } from '../../model/bidding';
import { AuthenticationService } from '../../services/authentication.service';

// @ts-ignore
import * as am4core from "@amcharts/amcharts4/core";
// @ts-ignore
import * as am4charts from "@amcharts/amcharts4/charts";
// @ts-ignore
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

declare var $: any;
@Component({
  selector: 'app-sales-funnel-report',
  templateUrl: './sales-funnel-report.component.html',
  styleUrls: ['./sales-funnel-report.component.css'],
  providers: [DBService, AuthenticationService]
})
export class SalesFunnelReportComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  activities: Activity[];
  displayActivities: Activity[];

  items: ActivityReportItem[];

  loading: boolean;

  emptyData: boolean;

  displayBiddings: Bidding[];
  biddings: Bidding[];

  totalCount: number;
  acceptedCount: number;
  pastCount: number;
  earnedCount: number;

  acceptedPercentage: number;
  pastPercentage: number;
  earnedPercentage: number;

  userCompanyUID: string;

  constructor(private dbService: DBService, private authService: AuthenticationService, private zone: NgZone) {
    this.companyFilter = '0';
    this.emptyData = true;

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadCompanies();
    this.loadBiddings();
  }

  private loadBiddings() {
    this.dbService.listWithUIDs<Bidding>('biddings')
      .then(biddings => this.biddings = biddings);
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
          this.companyFilter = this.userCompanyUID;
        } else {
          this.companies = companies;
        }
      });
  }

  search() {
    this.emptyData = false;

    this.displayBiddings = this.biddings
      .filter(a => a.biddingDate >= this.initialDate)
      .filter(a => a.biddingDate <= this.endDate);

    if (this.companyFilter != '' && this.companyFilter != '0') {
      this.displayBiddings = this.displayBiddings.filter(a => a.companyUID == this.companyFilter);
    }

    if (this.displayBiddings.length === 0) {
      this.initEmptyData();
    } else {
      this.initData();
    }
  }

  private initEmptyData() {

    this.totalCount = 0;
    this.acceptedCount = 0;
    this.pastCount = 0;
    this.earnedCount = 0;

    this.loading = false;
    this.loadChart();

  }

  private initData() {
    this.loading = true;

    this.totalCount = this.displayBiddings.length;
    this.acceptedCount = this.displayBiddings.filter(b => b.status != BiddingStatus.NEW && b.status != BiddingStatus.REFUSED).length;
    this.pastCount = this.displayBiddings.filter(b => b.status == BiddingStatus.EARNED || b.status == BiddingStatus.LOST).length;
    this.earnedCount = this.displayBiddings.filter(b => b.status == BiddingStatus.EARNED).length;

    this.loading = false;
    this.loadChart();

  }

  private loadChart() {
    this.zone.runOutsideAngular(() => { 

      let chart = am4core.create("chartdiv", am4charts.SlicedChart);
      chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
      
      console.log("Total de propostas " + this.totalCount);
      console.log("O cliente aceitou a proposta " + this.acceptedCount);
      console.log("Já ocorreu o pregão " + this.pastCount);
      console.log("Venceu a licitação " + this.earnedCount);

      chart.data = [
        {
            "name": "Total de propostas",
            "value": this.totalCount
        }, 
        {
            "name": "O cliente aceitou a proposta",
            "value": this.acceptedCount
        }, 
        {
            "name": "Já ocorreu o pregão",
            "value": this.pastCount
        },
        {
          "name": "Venceu a licitação",
          "value": this.earnedCount
        }
      ];
      
      let series = chart.series.push(new am4charts.FunnelSeries());
      series.colors.step = 2;
      series.dataFields.value = "value";
      series.dataFields.category = "name";
      series.alignLabels = true;
      
      series.labelsContainer.paddingLeft = 15;
      series.labelsContainer.width = 200;
      
      //series.orientation = "horizontal";
      //series.bottomRatio = 1;
      
      chart.legend = new am4charts.Legend();
      chart.legend.position = "left";
      chart.legend.valign = "bottom";
      chart.legend.margin(5,5,20,5);
    });
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }


  async delay(ms: number) {
      await new Promise(resolve => setTimeout(()=>resolve(), ms));
  }

  onChangeStartDate(event) {

    this.delay(1000).then(any => {
    
      this.initialDateString = event.target.value;
      const dateParts = this.initialDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.initialDate;
      } else {
        this.initialDate = date.getTime();
      }

    });

  }

  onChangeEndDate(event) {

    this.delay(1000).then(any => {

      this.endDateString = event.target.value;
      const dateParts = this.endDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.endDate;
      } else {
        this.endDate = date.getTime();
      }

    });
    
  }
}

export class ActivityReportItem {
  icon: string;
  title: string;
  total: number;
  done: number;
  pending: number;
  problem: number;
}


// WEBPACK FOOTER //
// ./src/app/pages/sales-funnel-report/sales-funnel-report.component.ts